var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    _c(
      "div",
      { staticClass: "card-content" },
      [
        _c("h1", { staticClass: "title is-3 has-text-centered" }, [
          _vm._v("Carga masiva de usuarios"),
        ]),
        _vm._v(" "),
        _c("h2", { staticClass: "subtitle is-5 has-text-centered" }, [
          _vm._v("Cargue un CSV para hacer una carga masiva de usuarios"),
        ]),
        _vm._v(" "),
        _c("b-message", { attrs: { type: "is-primary" } }, [
          _c("div", { staticClass: "content" }, [
            _c("p", [
              _c("b", [_vm._v("Nota:")]),
              _vm._v(" Puede descargar el siguiente template de ejemplo: "),
              _c(
                "a",
                {
                  attrs: {
                    href: "/statics/batch-usuarios-template.csv",
                    target: "_blank",
                  },
                },
                [_c("i", { staticClass: "fas fa-file" }), _vm._v(" Descargar")]
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label", attrs: { for: "" } }, [
            _vm._v("Subir CSV"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "control" }, [
            _c("div", { staticClass: "file has-name is-fullwidth" }, [
              _c("label", { staticClass: "file-label" }, [
                _c("input", {
                  staticClass: "file-input",
                  attrs: { type: "file", accept: "text/csv", name: "resume" },
                  on: {
                    change: function ($event) {
                      return _vm.processFile($event)
                    },
                  },
                }),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c("span", { staticClass: "file-name" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.file
                          ? _vm.file.name
                          : "Seleccione un archivo .csv para subir"
                      ) +
                      "\n              "
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _vm.error
          ? _c("b-message", { attrs: { type: "is-danger" } }, [
              _vm._v("\n      " + _vm._s(_vm.error) + "\n    "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "buttons is-centered" }, [
          _c(
            "button",
            {
              staticClass: "button is-dark is-outlined",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$parent.close()
                },
              },
            },
            [_vm._v("Cancelar")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "button is-primary",
              attrs: { type: "button" },
              on: { click: _vm.submit },
            },
            [_vm._v("Cargar")]
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "file-cta" }, [
      _c("span", { staticClass: "file-icon" }, [
        _c("i", { staticClass: "fas fa-search" }),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "file-label" }, [
        _vm._v("\n                  Examinar...\n                "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }